import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
//let serverUrl = ("http://localhost:3000")
import i18n from '@plugins/i18n'

export const getters = {
  getFieldFields() {
    return {
      model: 'repositories_field',
      label: 'Fields',
      fields: [
        { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
        { key: 'order', label: 'Order', type: 'number', sortable: true, required: true },
      ]
    }
  },
}

export const actions = {
  async fetchFields(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/fields/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createFields(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/fields/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateFields(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/fields/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteFields(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/fields/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}